import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import StorageEditModal from './StorageEditModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  status: state.modal.storageEditModal.status,
  asset: state.modal.storageEditModal.asset,
  tags: state.tag.list
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_STORAGE_EDIT, { status: false }),
  replaceStorageFileById: actions.storage.replaceStorageFileById,
  updateProperties: actions.storage.updateProperties,
  setTable: actions.storage.setTable,
  addTags: actions.storage.addTags
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StorageEditModal)



// WEBPACK FOOTER //
// ./src/components/Modals/StorageEditModal/index.js